































import { Vue, Component } from 'vue-property-decorator';

import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';
import RadioButton from '@/components/Atoms/Input/RadioButton.vue';
import Price from '@/components/Atoms/Text/Price.vue';

@Component({
  components: {
    UnorderedList,
    ListItem,
    RadioButton,
    Price,
  },
})
// 10G対応の無線LANルーターをレンタルしますか。
export default class Rental10gWifiRouter extends Vue {
  public selectRadioList: { id: string; text: string, price: number }[] = [
    {
      id: 'router_10g_rental',
      text: 'レンタルする　',
      price: 500
    },
    {
      id: 'not_rental',
      text: 'レンタルしない',
      price: 0
    },
  ];
  mounted() {
    const value = this.$store.getters['hikari/router']
    if (value === 'router_10g_rental' || value === 'not_rental') {
      this.$store.commit(`hikari/router`, value);
    } else {
      this.$store.commit(`hikari/router`, 'router_10g_rental');
    }
  }
}
